import React from "react";
import Routes from "./Routes";
import { AuthProvider } from "context/AuthProvider";
import { QueryClient, QueryClientProvider } from "react-query";

// Create a single QueryClient instance
const queryClient = new QueryClient();

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <Routes />
      </AuthProvider>
    </QueryClientProvider>
  );
}

export default App;
